(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-features-carousel]').forEach(function (root) {
  var track = root.querySelector('[data-features-track]');
  var slides = root.querySelectorAll('[data-features-slide]');
  var dots = root.querySelectorAll('[data-features-dot]');
  var prevBtn = root.querySelector('[data-features-prev]');
  var nextBtn = root.querySelector('[data-features-next]');
  var index = 0;
  var total = slides.length;
  var autoplay = root.getAttribute('data-autoplay') === 'true';
  var autoplaySpeed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 5000;
  var timer = null;

  if (total <= 1 || !track) return;

  function goTo(i) {
    index = (i + total) % total;
    track.style.transform = 'translateX(-' + (index * 100) + '%)';
    dots.forEach(function (dot, di) {
      dot.classList.toggle('is-active', di === index);
    });
  }

  function next() { goTo(index + 1); }
  function prev() { goTo(index - 1); }

  function startAutoplay() {
    if (!autoplay) return;
    stopAutoplay();
    timer = setInterval(next, autoplaySpeed);
  }
  function stopAutoplay() {
    if (timer) clearInterval(timer);
  }

  if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
  if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      goTo(parseInt(dot.getAttribute('data-index'), 10));
      startAutoplay();
    });
  });

  root.addEventListener('mouseenter', stopAutoplay);
  root.addEventListener('mouseleave', startAutoplay);

  goTo(0);
  startAutoplay();
});

  } catch(e) { console.error(e); }
})();
})();
